export const columns = [
  {
    field: 'label',
    headerName: 'Day()',
    flex: 1,
    minWidth: 170,
  },

  {
    field: 'in',
    headerName: 'In (days)',
    width: 120,
  },
]

export const datFS = {
  md: '55px',
  sm: '30px',
  xs: '25px',
}
